import React, { Component, createRef } from "react";
import style from "./Style.module.css";
import Util from "../../Util";
import mag1 from "../../asset/mag1.svg";
import mag2 from "../../asset/mag2.svg";
import SellSheet from "../../Components/ShopSheetNew";
import SheetCard from "../SheetCard";
class Quicksearch extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = createRef();
    this.isDrag = false;
    this.state = {
      search: "",
      sheets: [],
    };
  }

  async componentDidMount() {
    this.search(null, true);
  }

  render() {
    return (
      <div className={style.Container}>
        <div className={style.searchBox}>
          <div className={style.mag}>
            <img src={mag1} className={style.mag1} alt="mag1" />
            <img src={mag2} className={style.mag2} alt="mag2" />
          </div>
          <input
            placeholder="วิชา"
            className={style.textBox}
            type="text"
            onChange={this.search}
            value={this.state.search}
          />
        </div>
        <div
          className={style.searchSheets}
          ref={this.containerRef}
          onMouseDown={this.handleMouseDown}
          onMouseLeave={this.handleMouseLeave}
          onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove}
        >
          {this.renderStuff()}
        </div>
      </div>
    );
  }

  search = async (event, initialsearch = false) => {
    const search = event ? event.currentTarget.value : "";
    this.setState({ search });

    // Don't search less than 5 characters
    if (!initialsearch && search.length > 0 && search.length < 3) {
      return;
    }

    var data = await Util.sendPost("/api/public/searchSheetTop", {
      search: search.toLowerCase(),
    });
    this.setState({ sheets: data.data });
  };

  renderStuff = () => {
    return this.state.sheets.map((sheet, index) => {
      return (
        <SheetCard
          addCart={this.props.addCart}
          sheet={sheet}
          color={sheet?.color}
          index={index}
          callbackClick={() => {
            if (!this.isDrag) window.open(`/infoSheet/${sheet._id}`, "_blank");
          }}
        />
      );
    });
  };

  handleMouseDown = (e) => {
    this.isDrag = false;
    this.isDown = true;
    const container = this.containerRef.current;
    container.style.cursor = "grabbing";
    this.startX = e.pageX - container.offsetLeft;
    this.scrollLeft = container.scrollLeft;
  };

  handleMouseLeave = () => {
    this.isDown = false;
    this.containerRef.current.style.cursor = "grab";
  };

  handleMouseUp = () => {
    this.isDown = false;
    this.containerRef.current.style.cursor = "grab";
    setTimeout(() => {
      this.isDrag = false;
    }, 100);
  };

  handleMouseMove = (e) => {
    if (!this.isDown) return;
    e.preventDefault();
    const container = this.containerRef.current;
    const x = e.pageX - container.offsetLeft;
    const walk = x - this.startX;
    container.scrollLeft = this.scrollLeft - walk;

    const deltaX = Math.abs(e.clientX - this.startX);
    const deltaY = Math.abs(e.clientY - this.startY);
    // ถ้าเคลื่อนที่เกิน 5px ถือว่ากำลัง drag
    if (deltaX > 5 || deltaY > 5) {
      this.isDrag = true;
    }
  };
}

export default Quicksearch;
